import styled from "styled-components";

export const Maincard1=styled.div` 
border: 1px solid transparent;
width: 93%;
margin: auto;
`;

export const Head1=styled.p`
margin-left: 1%;
margin-top: 10%;
font-size: 7vh
`;

export const CartBox=styled.p`
 width: 100%;
 border: 1px solid transparent;
 display: flex;
 margin: auto;
`;

export const RightCard=styled.div` 
border: 1px solid lightgrey;
margin: 1%;
width: 30%;
height: 270px;
`;

export const LeftCard=styled.div` 
border: 1px solid lightgrey;
width: 70%;
margin: 1%;
`;


export const MidCard=styled.div` 
border: 1px solid transparent;
width: 95%;
margin: 2%;
height: 349px;
display: flex;
`;

export const ImgDiv=styled.div` 
border: 1px solid transparent;
width: 260px;
height: 260px;

`;

export const IMAGE=styled.img` 
width: 100%;


`;

export const ProductD=styled.div` 
border: 1px solid transparent;
height: 307px;
margin-left: 3%;
width: 60%;
`

export const SelectBox1=styled.select` 
 margin:10% 6% 0% 0%;
 width: 15%;
 cursor: pointer;
 height: 35px;
 text-align: center;
 border-radius: 4px;
 border: gray 1px solid;
 padding-left: 10px;
`;


export const RED1=styled.p` 
color:rgb(189,30,42);
margin: 10px 0px 5px 0px;
font-size: larger;
font-weight:bolder;
`;

export const RED2=styled.p` 
color:rgb(189,30,42)

`;

export const Para1=styled.p` 
margin: 10px 0px 5px 0px;
font-size: large;
`;

export const Para2=styled.p` 
margin: 10px 0px 5px 0px;
font-size: large;
`;

export const Under=styled.p` 
margin: 10px 0px 5px 0px;
text-decoration: line-through;
color: slategray;
`;

export const Lowlink=styled.div` 
display: flex;
text-decoration: underline;
`;


export const Linkdiv=styled.div` 
margin:20px 50px 0px 0px;
`;

export const CartDiv=styled.div` 
margin: 6%;
`;

export const Para3=styled.p` 
font-size: larger;
text-align: center;
color: rgb(47,51,55)
`;

export const Box1=styled.div`
color: rgb(47,51,55);
margin: 10px;
display: flex;
justify-content: space-between;
`;

export const Checkout=styled.button` 
width: 100%;
height: 44px;
border-radius: 4px;
background-color: rgb(47,51,55);
font-size: larger;
color: whitesmoke;
margin: 5% 1% 1% 0%;
border: none;
cursor: pointer;
`;

export const Big=styled.p` 
font-size: larger;
font-weight: bolder;
`;

export const Gray=styled.span` 
color:slategray;
`;